import React, { Component, Fragment } from 'react';
import { isEmpty } from "lodash";
import { Grid, Card, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton, FormControl, Select, InputLabel, MenuItem, OutlinedInput, Button, TextField, FormHelperText, Box } from '@mui/material';

import { Edit, Delete, CardGiftcard } from '@mui/icons-material';
import FileUpload from '../../common/FileUpload';
import DatePicker from '../../common/DatePicker';
import Currency from '../../common/Currency';
import InputText from '../../common/Form';

class ProjectStepForm extends Component {
    state = { 
        project_step_payment_mode: "",
        // project_step_bank: "",
        project_step_amount: "",
        project_step_ref: "",
        project_step_name: "",
        project_step_desc: "",
        project_step_date: new Date(),
        project_step_files: null,
        
        errors: {
            // project_step_user_id: "",
            project_step_date: "",
            project_step_ref: "",
            project_step_name: "",
            project_step_desc: "",
            // project_step_payment_mode: "",
            // project_step_bank: "",
            project_step_amount: "",
            project_step_files: "",
        },
        available: ""
        
    }

    handleChange = (e) => {
        const { name, value} = e.target;
        
        this.setState({
            [name]: value
        })
    }

    handleChangeDate = (date) => {
        this.setState({
            project_step_date: date
        })
    }

    setFiles = (project_step_files, error = "") => {
        console.log("[INFO] SET_PHOTO", project_step_files);
        this.setState({
            project_step_files,
            errors:{
                ...this.state.errors,
                project_step_files:error
            }
        })
    }
    validate = () => {
        let required = [
            // "project_step_user_id",
            "project_step_amount",
            "project_step_ref",
            "project_step_name",
            "project_step_desc",
            // "project_step_payment_mode",
            // "project_step_bank",
            // "project_step_files"
        ]

        let noError = true
        let errors = {}
        
        required.map(field => {
            if( isEmpty(this.state[field]) ) { // isEmpty doesn't work on dates, ! doesn't work for arrays
                console.log(`${field} is empty`)
                noError =  false
                errors[field] = "Veuillez remplir ce Champ" 
            } else {
                errors[field] = "" 
            }
        })

        this.setState({
            errors
        })
        
        return noError
    }
    handleSubmit = async () => {

        if( this.validate() ){
            let data = {}
            data.project_step_user_id = this.props.project_step_user_id
            data.project_id = this.props.project_id
            data.project_step_amount =  parseFloat(this.state.project_step_amount)
            // data.project_step_payment_mode =  this.state.project_step_payment_mode
            // data.project_step_bank =  this.state.project_step_bank
            data.project_step_desc =  this.state.project_step_desc
            data.project_step_ref =  this.state.project_step_ref
            data.project_step_name =  this.state.project_step_name
            data.project_step_files =  this.state.project_step_files
            data.project_step_date =  this.state.project_step_date

            console.log('====================================');
            console.log("submit debit", {data});
            console.log('====================================');
            await this.props.newProjectStep(data)
            
            // // if NoErrors ...
            if(this.props.STATE.steps.error){
                this.props.notif("error",`Un problème est survenu: ${this.props.STATE.steps.error}`)
            } else { 
                this.props.notif("success", "Enregistré")
                this.props.handleClose()
            }
        } else {
            this.props.notif("error", "Le formulaire contient des erreurs")
        }
    }
    
    render() {
        const { BANKS, USERS, CREDITS } = this.props;
        console.log('====================================');
        console.log(this.state);
        console.log('====================================');
        return (
            <Dialog
                // disableBackdropClick
                open={true}
                // onClose={this.props.handleClose}
                onClose={(_, reason) => {reason !== "backdropClick" && this.props.handleClose()} }
                aria-labelledby="form-dialog-title"
                fullWidth
                maxWidth= "sm"
                scroll="body"
            >
                <DialogTitle id="form-dialog-title">Nouvelle Etape Projet</DialogTitle>
                <Box p={1}></Box>
                <DialogContent>
                    {/* <Grid container spacing={2}> */}
                        <Box p={1}>
                            <DatePicker  
                                id="project_step_date" 
                                label="Date de Paiement" 
                                name="project_step_date" 
                                value={this.state.project_step_date} 
                                handleChange={this.handleChangeDate} 
                                error={this.state.errors.project_step_date}
                                required
                                noPadding
                            />      
                        </Box>   
                        <InputText
                            onChange={this.handleChange}
                            required
                            id="project_step_name"
                            error={!!this.state.errors.project_step_name}
                            helperText={this.state.errors.project_step_name}
                            value={this.state.project_step_name}
                            name="project_step_name"
                            label="Nom"
                        />
                        <InputText
                            onChange={this.handleChange}
                            required
                            id="project_step_amount"
                            error={!!this.state.errors.project_step_amount}
                            helperText={this.state.errors.project_step_amount}
                            value={this.state.project_step_amount}
                            name="project_step_amount"
                            label="Montant"
                            type="number"          
                        />
            
                        <InputText
                            onChange={this.handleChange}
                            required
                            id="project_step_ref"
                            error={!!this.state.errors.project_step_ref}
                            helperText={this.state.errors.project_step_ref}
                            value={this.state.project_step_ref}
                            name="project_step_ref"
                            label="Référence"
                        />
                        <InputText
                            onChange={this.handleChange}
                            required
                            id="project_step_desc"
                            error={this.state.errors.project_step_desc}
                            value={this.state.project_step_desc}
                            name="project_step_desc"
                            label="Description"
                            rows={5}
                            multiline
                        />
                        {/* <Grid item xs={12}>
                            <FormControl required error={!!this.state.errors.project_step_payment_mode} variant="outlined" style={{ width:'100%'}}>
                                <InputLabel htmlFor="project_step_payment_mode">Mode de Paiement</InputLabel>
                                <Select
                                    value={this.state.project_step_payment_mode}
                                    onChange={this.handleChange}
                                    input={<OutlinedInput labelWidth={170} name="project_step_payment_mode" id="project_step_payment_mode" />}
                                >
                                    <MenuItem value="ESPECES">ESPECES</MenuItem>
                                    <MenuItem value="CHEQUE">CHEQUE</MenuItem>
                                    <MenuItem value="PRELEVEMENT">PRELEVEMENT</MenuItem>
                                    <MenuItem value="VIREMENT">VIREMENT</MenuItem>
                                    <MenuItem value="GAB">GAB</MenuItem>
                                    <MenuItem value="MOBILE MONEY">MOBILE MONEY</MenuItem>
                                </Select>
                                <FormHelperText >{this.state.errors.project_step_payment_mode}</FormHelperText>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} >
                            <FormControl variant="outlined"  error={!!this.state.errors.project_step_bank} style={{width: "100%"}}>
                                <InputLabel htmlFor="project_step_bank">Banque</InputLabel>
                                <Select
                                    native
                                    onChange={this.handleChange}
                                    error={!!this.state.errors.project_step_bank}
                                    value={this.state.project_step_bank}
                                    input={
                                        <OutlinedInput 
                                            labelWidth={60} 
                                            name="project_step_bank" 
                                            id="project_step_bank" 
                                        />
                                    }
                                >
                                    <option value= "" />
                                    { Object.values(BANKS).map( bank  => (
                                        <option value={bank.bank_id} key={bank.bank_id}>
                                            {bank.bank_name}
                                        </option>
                                    )) }
                                </Select>
                                <FormHelperText>{this.state.errors.project_step_bank}</FormHelperText>
                            </FormControl>
                        </Grid>         */}
                        <Box p={1}>
                            <FileUpload
                                label="Ajouter une Photo"
                                setFiles={this.setFiles} 
                                files={this.state.project_step_files || []} 
                            />
                            <FormControl error={!!this.state.errors.project_step_files} >
                                <br/>
                                <FormHelperText >{this.state.errors.project_step_files}</FormHelperText>
                            </FormControl>
                        </Box>                
                    {/* </Grid> */}
                </DialogContent>
                <DialogActions>
                    <Button variant="contained" onClick={this.handleSubmit} color="secondary">
                        {/* <FormattedMessage id="form.update" defaultMessage="Créer" /> */}
                        Créer
                    </Button>
                    <Button onClick={this.props.handleClose} >
                        {/* <FormattedMessage id="form.cancel" defaultMessage="Annuler" /> */}
                        Annuler
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}

export default ProjectStepForm;